/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IMfrmAndroidBannerViewProps } from './mfrm-android-banner';
import { Image } from '@msdyn365-commerce/core';
import Close from 'mfcl/Icons/Close';

export default (props: IMfrmAndroidBannerViewProps) => {
    const { image, appName, companyName, body, ctaName, remindTime, manifest, starRatings } = props;
    const { cookies } = props.context.request;
    let deferredPrompt: any;
    const bannerCookie = cookies.get('AndroidBanner');
    const styles = 'android-app-banner-';

    if (typeof window !== 'undefined') {
        window.addEventListener('beforeinstallprompt', (e) => {
            e.preventDefault();
            deferredPrompt = e;
            if (bannerCookie.status === "NOT_FOUND") {
                const androidBanner = document.querySelector<HTMLElement>('.mfrm-android-banner-container');
                androidBanner!.style.display = 'flex';
            }
        });
    }

    if (typeof document !== 'undefined') {
        const linkManifest = document.createElement('link');
        linkManifest.rel = "manifest";
        linkManifest.href = manifest;
        document.getElementsByTagName('head')[0].appendChild(linkManifest);
    }

    const setCookie = () => {
        const time = new Date();
        const days = remindTime || 0;
        time.setTime(time.getTime() + (days * 24 * 60 * 60 * 1000));
        document.cookie = `AndroidBanner=false; expires=${time.toUTCString()}`;
    };

    const hideBanner = () => {
        const el = document.querySelector<HTMLElement>('.mfrm-android-banner-container');
        el!.style.display = 'none';
        setCookie();
    };

    const displayPrompt = () => {
        deferredPrompt.prompt();
        deferredPrompt.userChoice
            .then(() => {
                    hideBanner();
            });
    };

    return (
        <div className='mfrm-android-banner-container'>
            <Close className={`${styles}close`} width={25} height={25} onClick={() => {hideBanner();}}/>
            <div className={`${styles}icon`}>
                <Image
                    {...image}
                    alt={image?.altText || ''}
                    gridSettings={props.context.request.gridSettings!}
                    imageSettings={image?.imageSettings}
                    src={image?.src}
                />
            </div>
            <div className={`${styles}content`}>
                <div className={`${styles}name`}> {appName} </div>
                <div className={`${styles}company`}> {companyName} </div>
                <div className={`${styles}stars`}>
                    <Image {...starRatings} alt={starRatings?.altText || ''} gridSettings={props.context.request.gridSettings!} imageSettings={starRatings?.imageSettings} src={starRatings?.src} />
                    <Image {...starRatings} alt={starRatings?.altText || ''} gridSettings={props.context.request.gridSettings!} imageSettings={starRatings?.imageSettings} src={starRatings?.src} />
                    <Image {...starRatings} alt={starRatings?.altText || ''} gridSettings={props.context.request.gridSettings!} imageSettings={starRatings?.imageSettings} src={starRatings?.src} />
                    <Image {...starRatings} alt={starRatings?.altText || ''} gridSettings={props.context.request.gridSettings!} imageSettings={starRatings?.imageSettings} src={starRatings?.src} />
                    <Image {...starRatings} alt={starRatings?.altText || ''} gridSettings={props.context.request.gridSettings!} imageSettings={starRatings?.imageSettings} src={starRatings?.src} />
                </div>
                <div className={`${styles}text`}> {body} </div>
            </div>
            <a className={`${styles}btn`} onClick={() => displayPrompt()}> {ctaName} </a>
        </div>
    );
};